import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { CustomerDetailComponent } from './../customer-detail/customer-detail.component';
import { ContactHistoryComponent } from './../contact-history/contact-history.component';
import { DepositorInfoComponent } from './../depositor-info/depositor-info.component';
import { CustomerDaDataComponent } from './../customer-da-data/customer-da-data.component';
import { CustomerReqDocComponent } from './../customer-req-doc/customer-req-doc.component';
import { ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CustomerProfileComponent } from '@app/customer-profile/customer-profile.component';

declare var $: any
@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {

  contactId = ""
  emailaddress1 = ""
  telephone1 = ""
  dpa_idcard  = ""
  fullname = ""

  contact: any

  smsTmpList: any
  smsDesc: string
  emailTmpList: any
  emailDesc: string

  smsTemplate: any
  emailTemplate: any

  selectedSms = ""
  smsText = ""
  submittedSms= false

  selectedEmail = ""
  emailText = ""
  submittedEmail = false

  attachments = ""

  role:any = {}
  cookieData: any

  isCrisis = true

  @ViewChild(CustomerProfileComponent) profile: CustomerProfileComponent
  @ViewChild(CustomerDetailComponent) detail: CustomerDetailComponent
  @ViewChild(ContactHistoryComponent) history: ContactHistoryComponent
  @ViewChild(DepositorInfoComponent) depositor: DepositorInfoComponent
  @ViewChild(CustomerDaDataComponent) da: CustomerDaDataComponent
  @ViewChild(CustomerReqDocComponent) reqdoc: CustomerReqDocComponent

  @ViewChild('Depositor') Depositor: ElementRef
  @ViewChild('DATab') DATab: ElementRef
  @ViewChild('ReqDocTab') ReqDocTab: ElementRef

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private activatedRoute: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.isCrisis = this.cookieData.isCrisis

    if(!this.isCrisis){
      $(this.Depositor.nativeElement).removeAttr("data-toggle")
      $(this.Depositor.nativeElement).removeAttr("href")
      $(this.Depositor.nativeElement).addClass("disabled")
      $(this.DATab.nativeElement).removeAttr("data-toggle")
      $(this.DATab.nativeElement).removeAttr("href")
      $(this.DATab.nativeElement).addClass("disabled")
      $(this.ReqDocTab.nativeElement).removeAttr("data-toggle")
      $(this.ReqDocTab.nativeElement).removeAttr("href")
      $(this.ReqDocTab.nativeElement).addClass("disabled")
    }

    this.contactId = this.activatedRoute.snapshot.paramMap.get('id');

    await this.callApi()
    //await this.initDropdown()
 

    try {
      $('#summernote').summernote({
        placeholder: '',
        tabsize: 2,
        height: 120,
        toolbar: [
          ['style', ['style']],
          ['font', ['bold', 'underline', 'clear']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['table', ['table']],
          ['insert', ['link', 'picture', 'video']],
          ['view', ['fullscreen', 'codeview', 'help']]
        ]
      });

    }
    catch (e) {
      this.util.ShowWaiting(false)
    }
  }

  callApi(): Observable<any> {
    return forkJoin([
      this.initDropdown()
    ]);
  }

  async initDropdown() {
    this.smsTemplate = await this.apiService.get("master", "externalSmsTemplate")
    this.emailTemplate = await this.apiService.get("master", "externalEmailTemplate")
  }
 

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
  }
  async sms(){

    if(this.telephone1 == null || !this.util.isValidTelNo(this.telephone1)){
      this.util.WarningDialog("SMS ไม่ถูกต้อง")
    }
    else{
      $("#smsModal").modal('show')
    }
  }


  async email(){
    if(this.emailaddress1 == null || !this.util.isValidEmail(this.emailaddress1)){
      this.util.WarningDialog("Email ไม่ถูกต้อง")
    }
    else{
      this.selectedEmail = ""
      this.emailText = ""
      this.attachments = ""
      this.submittedEmail = false
      $('#summernote').summernote('code', '')
      $("#emailModal").modal('show')
    }
  }

  async confirmSMS(){
    this.submittedSms = true
    if (this.selectedSms != "") {
      this.util.ShowWaiting(true)


      let req: any = {
        contactid: this.contactId,
        dpa_description: "",
        dpa_phoneno: this.telephone1,
        template: this.selectedSms,
        dpa_createdby: this.cookieData.userId
      }
      let res: any = await this.apiService.post("crmservice", "sendSms", req)

      if (this.util.isSuccessResponse(res)) {
        $("#smsModal").modal('hide')
        this.util.SuccessDialog("ส่ง SMS สำเร็จ")
      }
      else {
        this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ")
      }

      this.util.ShowWaiting(false)
    }
  }

  async confirmEmail(){
    this.submittedEmail = true
    if (this.selectedEmail != "") {

      this.util.ShowWaiting(true)

      let req: any = {
        contactid: this.contactId,
        dpa_name: "",
        dpa_description: $('#summernote').summernote('code'),
        //dpa_emailaddress: this.emailaddress1,
        //template: this.selectedEmail,
        dpa_createdby: this.cookieData.userId,
        dpa_customwebuserid: this.cookieData.userId,
        dpa_callby: 1
      }
      let res: any = await this.apiService.post("crmservice", "sendEmail2", req)

      if (this.util.isSuccessResponse(res)) {
        this.util.SuccessDialog("ส่ง Email สำเร็จ")
        $("#emailModal").modal('hide')
      }
      else {
        this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ")
      }

      this.util.ShowWaiting(false)
    }
  }

  smsChange() {
    let selectd = this.smsTemplate.filter((e: any) => e.dpa_externalsmstemplateid == this.selectedSms)
    if (selectd != null && selectd.length > 0) {
      this.smsText = selectd[0].dpa_templatebodysms
    }
    else {
      this.smsText = ""
    }
  }

  emailChange() {
    let selectd = this.emailTemplate.filter((e: any) => e.templateid == this.selectedEmail)
    if (selectd != null && selectd.length > 0) {
      this.emailText = selectd[0].body
      $('#summernote').summernote('code', this.emailText)
      this.attachments = selectd[0].attachments.join(",")
    }
    else {
      this.emailText = ""
      this.attachments = ""
    }
  }

  onProfileTabClick(){
    console.log("onProfileTabClick")
    this.profile.init(this.contact)
  }

  onDetailTabClick(){
    console.log("onDetailTabClick")
    this.detail.init(this.contactId)
  }

  onHistoryTabClick(){
    console.log("onHistoryTabClick")
    this.history.init(this.contactId, this.fullname)
  }

  onDepositorTabClick(){
    if(this.isCrisis){
      console.log("onDepositorTabClick")
      this.depositor.init(this.contact)
    }
  }

  onDATabClick(){
    if(this.isCrisis){
      console.log("onDaTabClick")
      this.da.init(this.contactId)
    }
  }

  onreqdocTabClick(){
    if(this.isCrisis){
      console.log("onDaTabClick")
      this.reqdoc.init(this.contactId)
    }
  }

  async GetSavedContact(contact: any) {
    if(contact != null){
      this.contact = contact
      this.emailaddress1 = contact.emailaddress1
      this.telephone1 = contact.telephone1
      this.dpa_idcard = contact.dpa_idcard
      this.fullname = (contact.firstname == null ? "" : contact.firstname) + " " + (contact.lastname == null ? "" : contact.lastname)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.component.ts